import Store from './Store'

class StoreProvider {
  static store

  static async initialize(storeOptions) {
    const storeInstance = new Store(storeOptions)
    StoreProvider.store = await storeInstance.initialize()
  }

  static getStore() {
    if (!StoreProvider.store) {
      throw new Error('StoreProvider is not initialized')
    }

    return StoreProvider.store
  }
}

export default StoreProvider
